import { useCallback, useState } from 'react'
const useOrder = () => {
  const [orderBy, setOrderBy] = useState('')
  const [orderAsc, setOrderAsc] = useState(true)

  const onSort = useCallback(
    (key) => {
      if (key !== orderBy) {
        setOrderBy(key)
        setOrderAsc(true)
      } else {
        setOrderAsc((prevState) => {
          if (prevState === false) {
            setOrderBy('')
            return true
          } else {
            return false
          }
        })
      }
    },
    [orderBy],
  )
  return {
    orderBy,
    orderAsc,
    onSort,
  }
}

export default useOrder
